export function closePickerPanel(panel, restoreFocus) {
    panel.open.set(false);
    panel.handle.markAsTouched();
    return restoreFocus
        ? [{ type: "close-overlay" }, { type: "restore-focus", target: { part: "trigger" } }]
        : [{ type: "close-overlay" }];
}
